// Customer service definitions for the public-facing frontends.
// Used by: customer_area (B2B order form), mini_shop (prospect shop),
// contact_form, and care_ai (skin analysis).

// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file customer/customer.proto (package mw.customer, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AnalyzeSkinImagesRequest, AnalyzeSkinImagesResponse, AnalyzeSkinProblemsRequest, AnalyzeSkinProblemsResponse, AuthenticateRequest, AuthenticateResponse, CaptureMiniShopOrderRequest, CaptureMiniShopOrderResponse, ClearProductQuantitiesRequest, ClearProductQuantitiesResponse, CreateMiniShopOrderRequest, CreateMiniShopOrderResponse, CreateOrderRequest, CreateOrderResponse, DownloadInvoicePDFRequest, DownloadInvoicePDFResponse, ErrorRequest, ErrorResponse, GetMiniShopRequest, GetMiniShopResponse, GetOrderFormV2GroupedRequest, GetOrderFormV2GroupedResponse, GetOrderFormV2Request, GetOrderFormV2Response, GetOrdersRequest, GetOrdersResponse, GetOrderSummaryRequest, GetOrderSummaryResponse, GetProductRecommendationsRequest, GetProductRecommendationsResponse, GetSkinAnalysisFormRequest, GetSkinAnalysisFormResponse, GetSkinProblemsForAnalysisRequest, GetSkinProblemsForAnalysisResponse, GetStudentStatusRequest, GetStudentStatusResponse, GetSuggestedProductsRequest, GetSuggestedProductsResponse, RegisterStudentRequest, RegisterStudentResponse, RequestNewPasswordTokenRequest, RequestNewPasswordTokenResponse, SaveNewPasswordRequest, SaveNewPasswordResponse, SubmitContactFormRequest, SubmitContactFormResponse, TrackUsageRequest, TrackUsageResponse, UploadStudentDocumentsRequest, UploadStudentDocumentsResponse, ValidateAddressRequest, ValidateAddressResponse, ValidateMiniShopOrderRequest, ValidateMiniShopOrderResponse, VerifyStudentEmailRequest, VerifyStudentEmailResponse } from "./customer_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * CustomerService provides RPCs for authenticated B2B customers, student
 * registration, mini shop ordering, contact forms, and AI skin analysis.
 *
 * --- Authentication & Password Management ---
 *
 * @generated from service mw.customer.CustomerService
 */
export const CustomerService = {
  typeName: "mw.customer.CustomerService",
  methods: {
    /**
     * Authenticate validates email/password or refreshes an existing auth token.
     *
     * @generated from rpc mw.customer.CustomerService.Authenticate
     */
    authenticate: {
      name: "Authenticate",
      I: AuthenticateRequest,
      O: AuthenticateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * RequestNewPasswordToken sends a password reset email (if the address exists).
     *
     * @generated from rpc mw.customer.CustomerService.RequestNewPasswordToken
     */
    requestNewPasswordToken: {
      name: "RequestNewPasswordToken",
      I: RequestNewPasswordTokenRequest,
      O: RequestNewPasswordTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SaveNewPassword updates the password using a reset token or auth token.
     *
     * @generated from rpc mw.customer.CustomerService.SaveNewPassword
     */
    saveNewPassword: {
      name: "SaveNewPassword",
      I: SaveNewPasswordRequest,
      O: SaveNewPasswordResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetOrders returns all orders for the authenticated customer.
     *
     * @generated from rpc mw.customer.CustomerService.GetOrders
     */
    getOrders: {
      name: "GetOrders",
      I: GetOrdersRequest,
      O: GetOrdersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CreateOrder places a new order with selected products and delivery address.
     *
     * @generated from rpc mw.customer.CustomerService.CreateOrder
     */
    createOrder: {
      name: "CreateOrder",
      I: CreateOrderRequest,
      O: CreateOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetOrderSummary calculates totals for a cart or existing order.
     *
     * @generated from rpc mw.customer.CustomerService.GetOrderSummary
     */
    getOrderSummary: {
      name: "GetOrderSummary",
      I: GetOrderSummaryRequest,
      O: GetOrderSummaryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ClearProductQuantities removes saved quantities (auto-called after order creation).
     *
     * @generated from rpc mw.customer.CustomerService.ClearProductQuantities
     */
    clearProductQuantities: {
      name: "ClearProductQuantities",
      I: ClearProductQuantitiesRequest,
      O: ClearProductQuantitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * DownloadInvoicePDF downloads the invoice PDF for an order.
     *
     * @generated from rpc mw.customer.CustomerService.DownloadInvoicePDF
     */
    downloadInvoicePDF: {
      name: "DownloadInvoicePDF",
      I: DownloadInvoicePDFRequest,
      O: DownloadInvoicePDFResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetOrderFormV2 returns the order form with flat category/product line layout.
     *
     * @generated from rpc mw.customer.CustomerService.GetOrderFormV2
     */
    getOrderFormV2: {
      name: "GetOrderFormV2",
      I: GetOrderFormV2Request,
      O: GetOrderFormV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * GetOrderFormV2Grouped returns the order form with grouped table layout.
     *
     * @generated from rpc mw.customer.CustomerService.GetOrderFormV2Grouped
     */
    getOrderFormV2Grouped: {
      name: "GetOrderFormV2Grouped",
      I: GetOrderFormV2GroupedRequest,
      O: GetOrderFormV2GroupedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SubmitContactForm sends a contact form submission email to marketing.
     *
     * @generated from rpc mw.customer.CustomerService.SubmitContactForm
     */
    submitContactForm: {
      name: "SubmitContactForm",
      I: SubmitContactFormRequest,
      O: SubmitContactFormResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetMiniShop loads a mini shop by name and tracks the visit.
     *
     * @generated from rpc mw.customer.CustomerService.GetMiniShop
     */
    getMiniShop: {
      name: "GetMiniShop",
      I: GetMiniShopRequest,
      O: GetMiniShopResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ValidateMiniShopOrder validates order data and returns pricing.
     *
     * @generated from rpc mw.customer.CustomerService.ValidateMiniShopOrder
     */
    validateMiniShopOrder: {
      name: "ValidateMiniShopOrder",
      I: ValidateMiniShopOrderRequest,
      O: ValidateMiniShopOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CreateMiniShopOrder creates a PayPal order intent for a mini shop purchase.
     *
     * @generated from rpc mw.customer.CustomerService.CreateMiniShopOrder
     */
    createMiniShopOrder: {
      name: "CreateMiniShopOrder",
      I: CreateMiniShopOrderRequest,
      O: CreateMiniShopOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CaptureMiniShopOrder captures the PayPal payment after buyer approval.
     *
     * @generated from rpc mw.customer.CustomerService.CaptureMiniShopOrder
     */
    captureMiniShopOrder: {
      name: "CaptureMiniShopOrder",
      I: CaptureMiniShopOrderRequest,
      O: CaptureMiniShopOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ValidateAddress validates a postal address and returns field-level errors.
     *
     * @generated from rpc mw.customer.CustomerService.ValidateAddress
     */
    validateAddress: {
      name: "ValidateAddress",
      I: ValidateAddressRequest,
      O: ValidateAddressResponse,
      kind: MethodKind.Unary,
    },
    /**
     * TrackUsage records an analytics event for mini shop visits.
     *
     * @generated from rpc mw.customer.CustomerService.TrackUsage
     */
    trackUsage: {
      name: "TrackUsage",
      I: TrackUsageRequest,
      O: TrackUsageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Error logs a frontend error to the backend.
     *
     * @generated from rpc mw.customer.CustomerService.Error
     */
    error: {
      name: "Error",
      I: ErrorRequest,
      O: ErrorResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetSkinAnalysisForm returns the form configuration (image requirements + sliders).
     *
     * @generated from rpc mw.customer.CustomerService.GetSkinAnalysisForm
     */
    getSkinAnalysisForm: {
      name: "GetSkinAnalysisForm",
      I: GetSkinAnalysisFormRequest,
      O: GetSkinAnalysisFormResponse,
      kind: MethodKind.Unary,
    },
    /**
     * AnalyzeSkinProblems runs AI analysis on uploaded skin images.
     *
     * @generated from rpc mw.customer.CustomerService.AnalyzeSkinProblems
     */
    analyzeSkinProblems: {
      name: "AnalyzeSkinProblems",
      I: AnalyzeSkinProblemsRequest,
      O: AnalyzeSkinProblemsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetProductRecommendations returns products ranked by effectiveness for detected problems.
     *
     * @generated from rpc mw.customer.CustomerService.GetProductRecommendations
     */
    getProductRecommendations: {
      name: "GetProductRecommendations",
      I: GetProductRecommendationsRequest,
      O: GetProductRecommendationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetSkinProblemsForAnalysis returns available skin problems and the AI prompt.
     *
     * @generated from rpc mw.customer.CustomerService.GetSkinProblemsForAnalysis
     */
    getSkinProblemsForAnalysis: {
      name: "GetSkinProblemsForAnalysis",
      I: GetSkinProblemsForAnalysisRequest,
      O: GetSkinProblemsForAnalysisResponse,
      kind: MethodKind.Unary,
    },
    /**
     * AnalyzeSkinImages analyzes skin images and returns severity scores per problem.
     *
     * @generated from rpc mw.customer.CustomerService.AnalyzeSkinImages
     */
    analyzeSkinImages: {
      name: "AnalyzeSkinImages",
      I: AnalyzeSkinImagesRequest,
      O: AnalyzeSkinImagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetSuggestedProducts returns product suggestions based on skin scores.
     *
     * @generated from rpc mw.customer.CustomerService.GetSuggestedProducts
     */
    getSuggestedProducts: {
      name: "GetSuggestedProducts",
      I: GetSuggestedProductsRequest,
      O: GetSuggestedProductsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * RegisterStudent creates a new student account (public).
     *
     * @generated from rpc mw.customer.CustomerService.RegisterStudent
     */
    registerStudent: {
      name: "RegisterStudent",
      I: RegisterStudentRequest,
      O: RegisterStudentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * VerifyStudentEmail confirms the email address using a verification token.
     *
     * @generated from rpc mw.customer.CustomerService.VerifyStudentEmail
     */
    verifyStudentEmail: {
      name: "VerifyStudentEmail",
      I: VerifyStudentEmailRequest,
      O: VerifyStudentEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * UploadStudentDocuments uploads verification documents (requires auth_token).
     *
     * @generated from rpc mw.customer.CustomerService.UploadStudentDocuments
     */
    uploadStudentDocuments: {
      name: "UploadStudentDocuments",
      I: UploadStudentDocumentsRequest,
      O: UploadStudentDocumentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetStudentStatus returns the current verification status (requires auth_token).
     *
     * @generated from rpc mw.customer.CustomerService.GetStudentStatus
     */
    getStudentStatus: {
      name: "GetStudentStatus",
      I: GetStudentStatusRequest,
      O: GetStudentStatusResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

